



























import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import Checkbox from '../../core/components/Checkbox.vue';
import { ColorsList } from '../../core/utils';
import { CalibrationsPassesMap } from '../calibrations/model';

@Component({
    components: {
        Checkbox
    }
})
export default class ToggleCalibrationsPassesMap extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    whiteColor: string = ColorsList.white;
    activePasses: boolean = true;
    inactivePasses: boolean = true;

    updateActivePasses(value){
        this.activePasses = value;
        this.toggleCalibrationsFromMap();
    }
    updateInactivePasses(value){
        this.inactivePasses = value;
        this.toggleCalibrationsFromMap();
    }

    @Emit()
    toggleCalibrationsFromMap():CalibrationsPassesMap{
        return {
            actives: this.activePasses,
            inactives: this.inactivePasses
        }
    }
    
}
